
export const Branches = {
    LOADING_BRANCHES_LIST: "LOADING_BRANCHES_LIST",
    GET_BRANCHES_LIST: "GET_BRANCHES_LIST",
  };

